import React, { FC } from 'react';
import styled from 'styled-components';
import IconWithErrorBoundary from '@minecraft.icon';

type Props = {
  onClick: () => void;
  showPayPal: boolean;
};

const StyledPayPalButton = styled.button`
  border: none;
  border-radius: 0.25rem;
  width: 100%;
  height: 50px;
  padding: 12px 16px 12px 16px;
  min-width: 150px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.designSystem.bgColors.paypalBg};
  :hover {
    box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);
  }
`;

export const PayPal: FC<Props> = ({ onClick, showPayPal }) => {
  if (!showPayPal) return null;

  return (
    <StyledPayPalButton aria-label="Pay with PayPal" onClick={onClick}>
      <IconWithErrorBoundary name="paypal-with-title" />
    </StyledPayPalButton>
  );
};
